import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.OtherRequirement,
	portal: 'SP',
};

const basePath = 'Catalogs|Other Requirements|Edit History|';

export type SPOtherRequirementsEditHistoryLocNames =
	| 'SPOtherRequirementsEditHistoryPageTitle'
	| 'SPOtherRequirementsEditHistoryNoHistory';

export const spOtherRequirementsEditHistoryLocs: LocDefs<SPOtherRequirementsEditHistoryLocNames> = {
	SPOtherRequirementsEditHistoryPageTitle: {
		defaultValue: 'Other Requirements Catalog Edit History',
		description: 'The title of the page for viewing the edit history of other requirements.',
		displayPath: `${basePath}Page Title`,
		displayType: 'Title',
		legacyName: 'OtherRequirement/Catalogs.OtherRequirements.EditHistory.Title.PageTitle',
		...sharedProperties,
	},
	SPOtherRequirementsEditHistoryNoHistory: {
		defaultValue: 'No history available',
		description: 'The message displayed when there is no edit history for other requirements.',
		displayPath: `${basePath}No History`,
		displayType: 'Content',
		legacyName: 'OtherRequirement/Catalogs.OtherRequirements.EditHistory.Content.NoHistory',
		...sharedProperties,
	},
};

export type SPOtherRequirementsEditHistoryLocType = LocMap<SPOtherRequirementsEditHistoryLocNames>;
